// src/init/AppBootstrap.jsx
import { useEffect, useMemo, useState } from "react";
import { runInitTasks } from "./tasks";
import SplashScreen from "../components/SplashScreen";
import LoadingGate from "../components/LoadingGate";

export default function AppBootstrap({ children }) {
  const [phase, setPhase] = useState("splash"); // "splash" | "loading" | "ready" | "error"
  const [progress, setProgress] = useState({
    done: 0,
    total: 0,
    current: null,
  });
  const [error, setError] = useState(null);

  const onUpdate = useMemo(
    () => (evt) => {
      if (evt.type === "start") {
        setPhase("loading");
        setProgress({ done: 0, total: evt.total, current: null });
      } else if (evt.type === "step") {
        setProgress((p) => ({
          done: evt.index,
          total: p.total,
          current: evt.name,
        }));
      } else if (evt.type === "done") {
        setPhase("ready");
      }
    },
    []
  );

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await runInitTasks({ onUpdate });
        if (!cancelled) setPhase("ready");
      } catch (e) {
        console.error("App init failed:", e);
        if (!cancelled) {
          setError(e);
          setPhase("error");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [onUpdate]);

  if (phase === "splash") return <SplashScreen />;
  if (phase === "loading") return <LoadingGate progress={progress} />;
  if (phase === "error") {
    // Keep this simple; your AppErrorBoundary will handle app-level runtime errors.
    return (
      <div style={{ padding: 24 }}>
        <h1>App failed to initialize</h1>
        <pre style={{ whiteSpace: "pre-wrap" }}>
          {error?.message ?? String(error)}
        </pre>
      </div>
    );
  }

  return children; // ✅ Router & app render only when ready
}
